export default "/fonts/roboto-regular-webfont.woff?102cef347528778d9b277693a266ae11";